var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
import ReactDOM from 'react-dom';
import { App, AdminApp, PUBLIC_SELECTORS } from './App';
import * as serviceWorker from './serviceWorker';
import { defaultIntegrationName, createAxiosInstance, defaultAdminIntegrationName } from './httpService';
import set from "lodash/set";
import get from "lodash/get";
import merge from "lodash/merge";
import pickBy from "lodash/pickBy";
import assign from "lodash/assign";
import values from "lodash/values";
import entries from "lodash/entries";
import flattenDeep from 'lodash/flattenDeep';
import is from "is_js";
import { version } from "../package.json";
import { AppContext } from "./AppContext";
import { MODAL_CONTAINER_ID } from './components/Modal/modal.constants';
import { addFloatingButtons, createDomElement, getClassName, getRoute } from './helpers';
import { ToastContainer } from 'react-toastify';
import { MAIN_CONTAINER, MAIN_WRAP, TOAST, TOAST_CONTEXT, TOAST_CONTAINER, TOAST_PROGRESS } from './classConstants';
import { ThemedDiv } from './Theme';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import { getAdminContext } from './helpers/getAdminContext/getAdminContext';
import querystring from 'querystring';
import { persistCampaigns } from './helpers/campaign-manager';
var WithAppContextProvided = function (_a) {
    var contextValue = _a.contextValue, props = __rest(_a, ["contextValue"]);
    var _b = React.useState(__assign({}, contextValue)), context = _b[0], setContext = _b[1];
    var updateConfig = function (prop, value) { setContext(__assign(__assign({}, context), { config: merge({}, context.config, set({}, prop, value)) })); };
    var Component = contextValue.presentation.AppContext;
    if (Component) {
        return React.createElement(Component, { Provider: AppContext.Provider, value: contextValue, children: props.children });
    }
    return (React.createElement(AppContext.Provider, { value: __assign(__assign({}, context), { updateConfig: updateConfig }) }, props.children));
};
var AdminBookingForm = function (_a) {
    var bookingFormProps = _a.bookingFormProps, props = __rest(_a, ["bookingFormProps"]);
    var bookingFormRef = React.useRef(null);
    var updatedProps = React.useMemo(function () { return (__assign(__assign({}, (bookingFormProps || {})), { attributes: __assign(__assign({}, ((bookingFormProps === null || bookingFormProps === void 0 ? void 0 : bookingFormProps.attributes) || {})), props.attributes) })); }, [bookingFormProps, props.attributes]);
    return (React.createElement(React.Fragment, null,
        React.createElement(AdminApp, __assign({}, props, { apiBaseUrl: props.apiBaseUrl, bookingFormRef: bookingFormRef, name: "admin-cart", componentType: "WSADMINROOT" })),
        React.createElement(AdminApp, __assign({}, props, { apiBaseUrl: props.apiBaseUrl }, updatedProps, { bookingFormRef: bookingFormRef, name: "admin-booking-form", componentType: "WSADMINBOOKINGFORM" })),
        React.createElement("div", { ref: bookingFormRef })));
};
var ADMIN_FORM_BUTTONS_ID = "admin-form-buttons";
var getDefaultAdminConfig = function () { return ({
    apiPath: "/api/admin",
    appContext: getAdminContext({
        actionBarRef: { current: document.getElementById(ADMIN_FORM_BUTTONS_ID) }
    })
}); };
var Websail = /** @class */ (function () {
    function Websail(config) {
        if (config === void 0) { config = {}; }
        this.apiBaseUrl = "";
        this.apiBaseUrlObject = {};
        this.appContext = { presentation: {}, config: {}, updateConfig: function (prop, value) { } };
        this.proxyUrl = "";
        this.urlEncodePath = false;
        this.apiPath = "/api";
        this.defaultIntegrationName = defaultIntegrationName;
        this.redirectUrlParams = {};
        this.integrationName = "";
        this.hasInit = false;
        /**
         * List of legacy html5 elements supported.
         **/
        this.selectors = __spreadArray([], PUBLIC_SELECTORS);
        // To only enable polyfills for Set and Map;
        var x = new Set();
        var y = new Map();
        this.normalizeConfigAndAssign(config);
    }
    Object.defineProperty(Websail.prototype, "isCartDisabled", {
        get: function () {
            var _a, _b;
            return !!((_b = (_a = this.appContext) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.disableCart);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Instantiate an axios instance with the base URL.
     */
    Websail.prototype.setBaseApi = function () {
        createAxiosInstance(this.apiBaseUrlObject, {
            proxyUrl: this.proxyUrl,
            urlEncodePath: this.urlEncodePath,
            axiosInstance: this.axiosInstance,
            apiPath: this.apiPath
        });
    };
    /*
     * Copy Attributes from one element to the other.
     *
    */
    Websail.prototype.copyAttributes = function (from, to) {
        var length = from.attributes.length;
        for (var i = 0; i < length; i++) {
            var _a = from.attributes[i], name = _a.name, value = _a.value;
            var dataName = name.startsWith("data-") || ["class", "id"].includes(name) ? name : "data-" + name;
            to.setAttribute(dataName, value);
        }
        to.dataset.integrationName = to.dataset.integrationName || this.integrationName;
    };
    Object.defineProperty(Websail.prototype, "VERSION", {
        get: function () {
            return process.env.VERSION || version;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Websail.prototype, "LAST_COMMIT_DATE", {
        get: function () {
            return process.env.LAST_COMMIT_DATE_TIME;
        },
        enumerable: false,
        configurable: true
    });
    Websail.prototype.getCampaignName = function (config) {
        var _a = (config || {}).campaignName, campaignName = _a === void 0 ? "" : _a;
        var normalizeCampaignName = function (campaignName) {
            return (typeof campaignName === "string" ? campaignName.split(",") : values(campaignName)).map(function (x) { return x.trim(); });
        };
        return normalizeCampaignName(campaignName).concat(normalizeCampaignName(get(config, "appContext.config.campaignName", ""))).filter(Boolean).join(",");
    };
    Websail.prototype.provideContext = function (Component, props, context) {
        if (context === void 0) { context = {}; }
        return (React.createElement(WithAppContextProvided, { contextValue: merge({}, this.appContext, context) },
            React.createElement(Component, __assign({}, props))));
    };
    Websail.prototype.getIntegrationName = function (config) {
        return (this.integrationName || (config === null || config === void 0 ? void 0 : config.integrationName) || this.defaultIntegrationName).toLowerCase();
    };
    Websail.prototype.normalizeConfigAndAssign = function (config) {
        var _a;
        var _b = pickBy(config, function (x) { return x !== undefined; }), apiBaseUrl = _b.apiBaseUrl, skipApiBaseUrl = _b.skipApiBaseUrl, integrationName = _b.integrationName, campaignName = _b.campaignName, rest = __rest(_b, ["apiBaseUrl", "skipApiBaseUrl", "integrationName", "campaignName"]);
        if (!skipApiBaseUrl && apiBaseUrl === undefined)
            return;
        var baseConfig = {};
        this.integrationName = this.getIntegrationName(config);
        if (!skipApiBaseUrl && get(config, "appContext.config.is_admin")) {
            baseConfig = getDefaultAdminConfig();
        }
        rest = merge({}, baseConfig, { appContext: this.appContext }, rest, {
            appContext: {
                config: { campaignName: this.getCampaignName(config) }
            }
        });
        assign(this, __assign(__assign({}, rest), { apiBaseUrl: apiBaseUrl, apiBaseUrlObject: skipApiBaseUrl ? {} : (_a = {}, _a[this.integrationName] = apiBaseUrl, _a) }));
    };
    /**
     *
     * Turn legacy html5 elements into div with data-ws-type="LEGACY HTML5 ELEMENT"
     */
    Websail.prototype.normalizePlaceholders = function (selectors) {
        var _this = this;
        if (selectors === void 0) { selectors = this.selectors; }
        selectors.forEach(function (tagName) {
            Array.from(document.querySelectorAll(tagName)).forEach(function (el) {
                var _a;
                if (tagName === "WSROOT" && document.querySelectorAll("[data-ws-type=\"WSROOT\"]:not(:empty), [data-ws-type=\"WSPOPUPFORM\"], [data-ws-type=\"WSPOPUPBUTTON\"]").length > 0) {
                    (_a = el.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(el);
                    return;
                }
                var div = document.createElement(["WSUSERPREVIEW", "WSCARTPREVIEW"].includes(tagName) ? "span" : "div");
                _this.copyAttributes(el, div);
                var integrationName = (el.dataset.integrationName || _this.integrationName).toLowerCase();
                div.classList.add("ws-element");
                div.classList.add("ws-" + integrationName);
                div.dataset.wsType = tagName;
                el.parentNode.replaceChild(div, el);
            });
        });
    };
    /**
     * Check if all integrations in the DOM are loaded.
     * Checks length of .ws-element
     * Checks length of .websail in .ws-element
     */
    Websail.prototype.loadedAllIntegrations = function () {
        return (document.querySelectorAll('.ws-element').length == 0 || document.querySelectorAll('.ws-element').length >= document.querySelectorAll('.ws-element .websail').length);
    };
    /**
     * Attach DOM Mutation Observer
     * Most helpful with AJAX webpages.
     * On next page load, intialize supported components.
     */
    Websail.prototype.attachDomMutatorObserver = function () {
        var _this = this;
        var targetNode = document.body;
        var options = {
            subtree: true,
            attributes: false,
            childList: true,
        };
        var observerCallback = function (mutationList, observer) {
            _this.normalizePlaceholders();
            flattenDeep(mutationList.map(function (mutation) { return __spreadArray([], mutation.addedNodes); }, 1)).forEach(function (node) {
                var _a;
                if (!_this.loadedAllIntegrations()
                    || ((_a = node.classList) === null || _a === void 0 ? void 0 : _a.contains("ws-element"))
                    || (node.querySelector && node.querySelector(".ws-element"))) {
                    _this.run();
                }
            });
            flattenDeep(mutationList.map(function (mutation) { return __spreadArray([], mutation.removedNodes); }, 1)).forEach(function (node) {
                var _a;
                var reactNode = ((_a = node.classList) === null || _a === void 0 ? void 0 : _a.contains("ws-element")) ? node : (node.querySelector && node.querySelector(".ws-element"));
                if (!(reactNode === null || reactNode === void 0 ? void 0 : reactNode.querySelector(".websail"))) {
                    return;
                }
                ReactDOM.unmountComponentAtNode(reactNode);
            });
        };
        var observer = new MutationObserver(observerCallback);
        observer.observe(targetNode, options);
    };
    Websail.prototype.interceptAxiosRequests = function () {
        // Accept a hard coded redirect URL from the integration config. On payment success/failure the backend will always return to this path.
        var redirectURL = get(this, "redirectUrl");
        if (redirectURL) {
            try {
                redirectURL = redirectURL.endsWith("#") ? redirectURL : redirectURL + "#";
                var url = new URL(redirectURL);
                this.axiosInstance = axios.create({
                    headers: {
                        'X-WS-INTEGRATION-ADDRESS': url.href,
                        'X-WS-INTEGRATION-PARAMS': querystring.stringify(this.redirectUrlParams),
                    }
                });
                this.appContext.config.apiIntegrationAddress = url.href;
            }
            catch (_a) { }
        }
    };
    /**
     * Helper method to run the code.
     * Retries 2 times.
     *
     * TODO: Possibly not required to have timeout and run the code exactly once.
     */
    Websail.prototype.run = function () {
        this.tryInit();
        // for(let i = 1; i < 20; i++) {
        //   if(this.loadedAllIntegrations()) return;
        //   setTimeout(() => {
        //     if(this.loadedAllIntegrations()) return;
        //     this.tryInit();
        //   }, 100*i);
        // }
        var x = new Map();
        return Promise.resolve();
    };
    /**
     * Helper method to actually process all placeholder elements in DOM and initialize app in multiple places.
     */
    Websail.prototype.tryInit = function (Component, provideContext) {
        var _this = this;
        if (Component === void 0) { Component = App; }
        if (provideContext === void 0) { provideContext = true; }
        this.setBaseApi();
        var cancelled = false;
        Array.from(document.querySelectorAll('.ws-element')).forEach(function (el, index) {
            var _a, _b;
            if (cancelled)
                return;
            if (el.querySelector("." + MAIN_CONTAINER))
                return;
            if (!_this.apiBaseUrl && !el.dataset.integrationName) {
                !get(_this, "silent") && console.error("Configuration Error: Base url is not defined", el);
                return;
            }
            if (!el.dataset.integrationName) {
                el.dataset.integrationName = _this.integrationName;
            }
            if (el.dataset.integrationName !== _this.integrationName) {
                return;
            }
            var props = {
                index: index,
                apiBaseUrl: _this.apiBaseUrl,
                attributes: {
                    integrationName: el.dataset.integrationName,
                }
            };
            if (el.classList.contains("ws-element") && !((_a = el.dataset) === null || _a === void 0 ? void 0 : _a.wsType)) {
                cancelled = true;
                var nextEl = document.createElement("wsroot");
                _this.copyAttributes(el, nextEl);
                el.replaceWith(nextEl);
                return;
            }
            entries(el.dataset).reduce(function (props, _a) {
                var nodeName = _a[0], nodeValue = _a[1];
                if (!["wsType", "class"].includes(nodeName))
                    props.attributes[nodeName] = nodeValue;
                return props;
            }, assign(props, {
                componentType: (_b = el.dataset.wsType) === null || _b === void 0 ? void 0 : _b.toUpperCase(),
            }));
            ReactDOM.render(provideContext ? _this.provideContext(Component, props) : React.createElement(Component, __assign({}, props)), el);
        });
        if (this.isCartDisabled) {
            return;
        }
        ;
        if (this.integrationName === defaultAdminIntegrationName) {
            return;
        }
        ;
        addFloatingButtons(this.integrationName);
    };
    /**
     * Bootstrap method to load all scripts
     * Called from the customer side.
     */
    Websail.prototype.init = function (config) {
        if (config === void 0) { config = {}; }
        if (this.hasInit)
            return;
        this.hasInit = true;
        if (is.ie("<=10")) {
            return this.renderUnsupportedBrowser();
        }
        if (!document.getElementById(MODAL_CONTAINER_ID)) {
            var modalContainer = document.createElement("div");
            modalContainer.id = MODAL_CONTAINER_ID;
            modalContainer.style.zIndex = "1000";
            document.body.appendChild(modalContainer);
        }
        this.normalizeConfigAndAssign(config);
        this.normalizePlaceholders();
        this.addToastContainer();
        this.addGlobalListener();
        this.updateCampaigns();
        this.attachDomMutatorObserver();
        this.interceptAxiosRequests();
        this.run();
        this.replaceEventListeners();
        // If you want your app to work offline and load faster, you can change
        // unregister() to register() below. Note this comes with some pitfalls.
        // Learn more about service workers: https://bit.ly/CRA-PWA
    };
    /**
     * Bootstrap method to load all scripts
     * Called from the customer side.
     */
    Websail.prototype.initAdmin = function () {
        if (is.ie("<=10")) {
            return this.renderUnsupportedBrowser();
        }
        var token = Cookies.get('accessToken');
        if (!token) {
            return null;
        }
        if (!document.getElementById(MODAL_CONTAINER_ID)) {
            var modalContainer = document.createElement("div");
            modalContainer.id = MODAL_CONTAINER_ID;
            modalContainer.style.zIndex = "1000";
            document.body.appendChild(modalContainer);
        }
        axios.interceptors.request.use(function (config) {
            return config;
        });
        var App = this.getAdminApp();
        this.normalizePlaceholders(["WSROOT"]);
        this.tryInit(App, false);
    };
    /**
     * Monket patching onhashchange and onpopstate events
     * Only allow the events to pass application routes are not a part of the new URL
     */
    Websail.prototype.replaceEventListeners = function () {
        var _this = this;
        var windowEvents = [
            "onhashchange",
            "onpopstate"
        ];
        var _loop_1 = function (event) {
            {
                var eventListener_1 = get(window, event);
                if (!eventListener_1)
                    return "continue";
                set(window, event, function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (window.location.href.slice(-1) === "#" || window.location.hash === "#/" || _this.getRoute(window.location.hash.substring(1)))
                        return;
                    eventListener_1.call(window, args);
                });
            }
        };
        for (var _i = 0, windowEvents_1 = windowEvents; _i < windowEvents_1.length; _i++) {
            var event = windowEvents_1[_i];
            _loop_1(event);
        }
    };
    /**
     *
     * Check if @param hashUrl is an application route
     *
     */
    Websail.prototype.getRoute = function (hashUrl) {
        return getRoute(hashUrl);
    };
    Websail.prototype.renderUnsupportedBrowser = function () {
        Array.from(document.querySelectorAll(".ws-element[data-ws-type], wsroot, wsuser, wscourselist, wscoursetable, wscourseaccordion, wsbookcart")).forEach(function (el) {
            el.innerHTML = "\n        <div class=\"ws-browser-not-supported\">\n          <p>Your browser is outdated and is not supported by this site. Therefore, errors may occur when using the site. Also for security reasons you should update your browser as soon as possible. For example to the latest version of <a href=\u201Chttps://www.mozilla.org/de/firefox/new/\u201D target=\u201C_blank\u201D rel=\u201Cnoopener\u201D>Firefox</a>, <a href=\u201Chttps://www.google.com/chrome/\u201D target=\u201C_blank\u201D rel=\u201Cnoopener\u201D>Chrome</a> or <a href=\u201Chttps://www.microsoft.com/de-de/edge\u201D target=\u201C_blank\u201D rel=\u201Cnoopener\u201D>Edge</a>.</p>\n        </div>\n        <style>\n          .ws-browser-not-supported {\n            padding: 10px;\n            color: #a94442;\n            border: 1px solid #a94442;\n            border-radius: 6px;\n            background: #f8d7da;\n            margin-bottom: 1em;\n          }\n          .ws-browser-not-supported p{\n            color: inherit;\n            margin: 0;\n          }\n        </style>\n      ";
        });
    };
    Websail.prototype.getAdminApp = function () {
        var _this = this;
        document.body.appendChild(createDomElement({
            id: ADMIN_FORM_BUTTONS_ID,
            el: "div",
            html: ""
        }));
        this.integrationName = defaultAdminIntegrationName;
        this.normalizeConfigAndAssign({
            apiBaseUrl: this.apiBaseUrl,
            appContext: {
                config: { is_admin: true }
            }
        });
        var attributes = { integrationName: this.integrationName };
        this.setBaseApi();
        this.addToastContainer();
        return function (_a) {
            var props = __rest(_a, []);
            return _this.provideContext(AdminBookingForm, __assign(__assign({}, props), { attributes: __assign(__assign({}, props.attributes), attributes) }));
        };
    };
    Websail.prototype.addToastContainer = function () {
        var toastContainerId = "ws-toast-container";
        if (document.querySelector("#" + toastContainerId)) {
            return;
        }
        var toastProps = {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            newestOnTop: true,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            containerId: toastContainerId,
            draggable: false,
            className: function (_a) {
                var _b = _a === void 0 ? {} : _a, defaultClassName = _b.defaultClassName;
                return getClassName(defaultClassName, TOAST_CONTAINER);
            },
            toastClassName: function (context) { return getClassName(context === null || context === void 0 ? void 0 : context.defaultClassName, TOAST, TOAST_CONTEXT[context === null || context === void 0 ? void 0 : context.type]); },
            progressClassName: TOAST_PROGRESS
        };
        var toastContainerTag = createDomElement({
            id: toastContainerId,
            el: "div",
            html: ""
        });
        document.body.appendChild(toastContainerTag);
        ReactDOM.render(React.createElement(ThemedDiv, { className: MAIN_WRAP },
            React.createElement(ToastContainer, __assign({}, toastProps))), toastContainerTag);
    };
    Websail.prototype.updateCampaigns = function () {
        persistCampaigns({
            searchParams: new URL(window.location.href).search,
            campaignName: this.getCampaignName(this),
        });
    };
    Websail.prototype.addGlobalListener = function () {
        if (this.isCartDisabled) {
            return;
        }
        ;
        var key = this.getIntegrationName();
        var eventsContainer = "ws-events-container-" + key;
        if (document.querySelector("#" + eventsContainer)) {
            return;
        }
        var eventsContainerTag = createDomElement({
            id: eventsContainer,
            el: "WSGLOBALEVENTS",
            html: ""
        });
        eventsContainerTag.dataset.integrationName = key;
        document.body.appendChild(eventsContainerTag);
        this.normalizePlaceholders(["WSGLOBALEVENTS"]);
    };
    Websail.prototype.renderAppInPopup = function (_a) {
        var integrationName = _a.integrationName, children = _a.children, onClose = _a.onClose;
        if (document.querySelector("#ws-popup-booking-form")) {
            return;
        }
        var domEl = createDomElement({
            id: "ws-popup-booking-form",
            el: "div",
            html: "",
        });
        document.body.appendChild(domEl);
        ReactDOM.render(this.provideContext(function (props) { return React.createElement(App, __assign({}, props)); }, {
            componentType: "WSPOPUPFORM",
            attributes: { integrationName: integrationName },
            onModalClose: function () {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                document.body.removeChild(domEl);
            },
            children: children,
        }), domEl);
    };
    Websail.prototype.openWithBaseURL = function (_a) {
        var apiBaseUrl = _a.apiBaseUrl, _b = _a.redirectUrlParams, redirectUrlParams = _b === void 0 ? {} : _b, onClose = _a.onClose, _c = _a.integrationName, integrationName = _c === void 0 ? btoa(apiBaseUrl).replace(/\W/g, "") : _c, _d = _a.children, children = _d === void 0 ? null : _d;
        this.clone().init({ apiBaseUrl: apiBaseUrl, integrationName: integrationName.toLowerCase(), redirectUrlParams: redirectUrlParams });
        this.renderAppInPopup({ onClose: onClose, integrationName: integrationName.toLowerCase(), children: children });
    };
    Websail.prototype.clone = function () {
        var wsClone = new Websail();
        var skippedProps = ["hasInit", "integrationName", "apiBaseUrl", "apiBaseUrlObject", "axiosInstance", "redirectUrlParams"];
        entries(this).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (skippedProps.includes(key)) {
                return;
            }
            set(wsClone, key, value);
        });
        return wsClone;
    };
    Websail.defaultIntegrationName = defaultIntegrationName;
    return Websail;
}());
/**
 * Expose Websail class to the world.
 */
window.wsBundleIntegration = Websail;
window.websailBundle = new Websail();
serviceWorker.unregister();
export default Websail;
